import { render, staticRenderFns } from "./divpage.vue?vue&type=template&id=a51f9b76&scoped=true&"
import script from "./divpage.vue?vue&type=script&lang=js&"
export * from "./divpage.vue?vue&type=script&lang=js&"
import style0 from "./divpage.vue?vue&type=style&index=0&id=a51f9b76&prod&lang=less&scoped=true&"
import style1 from "./divpage.vue?vue&type=style&index=1&id=a51f9b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f9b76",
  null
  
)

export default component.exports